import { DataSource, DataSourceFileConfig } from '@/models/dataSource';
import { TFileData } from '@/models/fileUpload';

/**
 * Opt-in local debug only. Set `VITE_MOCK_CSV_HEADER_STEP=true` to skip upload and
 * bootstrap a parsed CSV fixture. Defaults off so create-flow always uses real upload.
 */
export const USE_MOCK_CSV_HEADER_STEP = import.meta.env['VITE_MOCK_CSV_HEADER_STEP'] === 'true';

export const MOCK_CSV_FILENAME = 'mock-column-mapping.csv';

/** Lazy-loads the fixture JSON so production bundles do not include it unless the flag is on. */
export async function loadMockCsvFixtures(): Promise<{
  MOCK_CSV_PARSED: TFileData;
  MOCK_CSV_FILENAME: string;
  buildMockFileDataSourceStash: () => Partial<DataSource<DataSourceFileConfig>>;
}> {
  const { default: parsedCsv } = await import('./mock-csv-parsed.json');
  const MOCK_CSV_PARSED = parsedCsv as TFileData;

  return {
    MOCK_CSV_PARSED,
    MOCK_CSV_FILENAME,
    buildMockFileDataSourceStash: () => ({
      name: 'Mock column mapping CSV',
      configuration: {
        filename: MOCK_CSV_FILENAME,
        isDefaultHeader: MOCK_CSV_PARSED.isDefaultHeader,
      } as DataSourceFileConfig & { filename: string },
    }),
  };
}
